import React from 'react'

import { useAuthModal, useUser } from '~/utils/hooks'

import AuthModals from '~/components/Header/components/RightSection/components/AuthModals/AuthModalsView'

import { HeaderProps } from '../../Header'

import { AuthButtons, LoginSectionMenu, MobileMenu, RightLinks } from './components'
import styles from './RightSection.module.css'

interface RightSectionProps extends Pick<
  HeaderProps,
  'rightLinks' | 'logo' | 'middleLinks' | 'additionalMobileMenuLinks' | 'headerTranslation' | 'buttonText' | 'redirectUrl' | 'voucherLabel'
> {
  mergedTheme: { [x: string]: string }
}

export function RightSection({
  mergedTheme,
  rightLinks,
  middleLinks,
  additionalMobileMenuLinks,
  logo,
  headerTranslation,
  buttonText,
  redirectUrl,
  voucherLabel,
}: RightSectionProps) {
  const { user, loading } = useUser({ returnBlankOnAnonymous: true })
  const { setModalType, modalType } = useAuthModal()

  return (
    <>
      <AuthModals modalType={modalType} setModalType={setModalType} />
      <div className={mergedTheme.right}>
        <RightLinks mergedTheme={mergedTheme} rightLinks={rightLinks} />
        {loading ? (
          <div className={styles.skeleton} />
        ) : user ? (
          <LoginSectionMenu {...{ user, rightLinks, mergedTheme, middleLinks, logo, headerTranslation }} />
        ) : (
          <AuthButtons buttonsTranslations={headerTranslation.buttons} setModalType={setModalType} />
        )}
      </div>
      <MobileMenu
        {...{
          middleLinks,
          additionalMobileMenuLinks,
          logo,
          mergedTheme,
          user,
          rightLinks,
          headerTranslation,
          buttonText,
          redirectUrl,
          voucherLabel,
          setModalType,
        }}
      />
    </>
  )
}
